<template>
    <div ref="snackbarContainer" :class="containerClass">
        <transition-group ref="transition" name="ur-snackbar__slide" tag="div">
            <div v-for="(snackbar, i) in snackbarList" :key="snackbar.idx+'.'+i" class="ur-snackbar">
                <div class="ur-snackbar__content">
                    {{snackbar.text}}
                </div>
                <div class="ur-snackbar__action">
                    <ur-button v-if="snackbar.closeBtn" borderless primary @click="clickCloseBtn(snackbar)">
                        Close <!--다국어-->
                    </ur-button>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
    import snackbarEvent from "./snackbarEvents";

    export default {
        name: "urGlobalSnackbar",
        props: {
            //global은 prop을 전달할 수 없으므로 전역 함수 param 으로 받는다
            // duration: {type:Number, default:2000},
            // closeBtn: {type:Boolean, default:false},
        },
        data() {
          return {
              snackbarList : [],
              snackbarIdx: 0,
              isHiding: false,
              isAdding: true,
              containerPosition:false,
          }
        },
        computed: {
            cDuration() {
                let rtn = this.duration * 1;
                return isNaN(rtn)? 2000 : rtn;
            },
            containerClass() {
                const rtn = [];
                rtn.push('ur-snackbar__container');
                rtn.push('ur-snackbar__container-bottom');
                //나중에 추가
                // if(this.containerPosition) {
                //     rtn.push('ur-snackbar__container-right');
                // } else {
                    rtn.push('ur-snackbar__container-center');
                // }
                // 추가중의 move인지 제거 중의 move인지 css가 구분할 수 있게 하기 위한 빈 클래스
                // 제거중의 move일 경우 제거되는 아이템이 사라질때 가지 기다렸다가 move가 시작될 수 있도록 시간 지연 입력
                if(this.isAdding) {
                    rtn.push('ur-snackbar__container-add');
                } else {
                    rtn.push('ur-snackbar__container-remove');
                }
                // width : auto를 보장하기 위한 장치
                // 없을 경우 마지막 아이템이 사라질 때 width가 측정되지 않아서 크기가 짜부러진 채로 사라지게 됨
                if(this.snackbarList.length > 0){
                    rtn.push('ur-snackbar__more-than-one-item');
                }
                return rtn;
            },
        },
        mounted() {
            snackbarEvent.$on('show-snackbar', this.showSnackbar);
            snackbarEvent.$on('add-snackbar', this.addSnackbar);
        },
        methods: {
            // @vuese
            // $ver: v0.1.0
            // $return: N/A
            // Vue 인스턴스 내에서 this.$showSnackbar를 통하여 snackbar를 표시합니다.
            // #Switch the button to the loading state. The loading indicator appears on the button and it cannot be clicked.
            showSnackbar(snackbar) {
                this.containerPosition = false;
                if(this.snackbarList.length > 0 || this.isHiding){
                    return;
                }
                snackbar.idx = 1;
                this.snackbarList.push(snackbar);
                setTimeout(() => {
                    this.close(snackbar);
                    this.isHiding = true;

                }, isNaN(snackbar.duration) ? 2000 : snackbar.duration)
            },
            // @vuese
            // $ver: v0.1.0
            // $return: N/A
            // Vue 인스턴스 내에서 this.$addSnackbar를 통하여 중첩가능한 snackbar를 표시합니다.
            // #Switch the button to the loading state. The loading indicator appears on the button and it cannot be clicked.
            addSnackbar(params) {
                this.containerPosition = true;
                const snackbar = JSON.parse(JSON.stringify(params));
                this.isAdding = true;
                this.snackbarIdx++;
                snackbar.idx = this.snackbarIdx;
                this.snackbarList.push(snackbar);
                setTimeout(() => {
                    this.close(snackbar);
                }, isNaN(snackbar.duration) ? 2000 : snackbar.duration)
            },
            close(snackbar){
                this.isAdding = false;
                let idx = this.snackbarList.indexOf(snackbar);
                if (idx > -1 ) {
                    this.snackbarList.splice(this.snackbarList.indexOf(snackbar), 1);
                }
                setTimeout(() => {
                    this.isHiding = false;
                }, 500)
            },
            clickCloseBtn(snackbar) {
                this.close(snackbar);
            },
            beforeLeave(el) {
                el.style.transitionDelay = '1000ms'
            },
            afterLeave(el) {
                el.style.transitionDelay = ''
            },
        }
    }
</script>